/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷先に自社センターを含む
 * @export
 * @interface InternalTransferHubFlg
 */
export interface InternalTransferHubFlg {
}

/**
 * Check if a given object implements the InternalTransferHubFlg interface.
 */
export function instanceOfInternalTransferHubFlg(value: object): value is InternalTransferHubFlg {
    return true;
}

export function InternalTransferHubFlgFromJSON(json: any): InternalTransferHubFlg {
    return InternalTransferHubFlgFromJSONTyped(json, false);
}

export function InternalTransferHubFlgFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalTransferHubFlg {
    return json;
}

export function InternalTransferHubFlgToJSON(json: any): InternalTransferHubFlg {
    return InternalTransferHubFlgToJSONTyped(json, false);
}

export function InternalTransferHubFlgToJSONTyped(value?: InternalTransferHubFlg | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

